// extracted by mini-css-extract-plugin
export default {"layout":"layout_MGxE23ri","header":"header_pKFCoI9t","body":"body_ceC7cPqG","content":"content_wOeETs5X","rightContent":"rightContent_bzYJEzu_"};